// betonijerry/src/utils/auth/jwtClaims.js
// Base64url decode of a JWT payload + an exp check. Shared by AuthContext, the
// ImpersonationBanner and TarjouspyyntoEsikatselu (non-app preview token).
//
// Prod mints v2 short-shape app tokens (JWT_SHORT_KEYS), so the payload goes
// through the shared codec's expandPayload. Long-shape and non-app tokens pass
// through unchanged.

import { expandPayload } from "@ibetoni/auth/codec";

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    return expandPayload(JSON.parse(atob(padded)), { onUnknownRole: "skip" });
  } catch {
    return null;
  }
}

// True if a JWT's exp is in the past. True for unparseable tokens too.
export function isJwtExpired(token) {
  const claims = decodeJwtPayload(token);
  if (!claims || typeof claims.exp !== "number") return true;
  return claims.exp * 1000 < Date.now();
}
